import React, { useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { IGraphDataPoint } from 'entities/cdn'

import { fetchPriceChart, IFiatCode, ITimeFrameValue } from 'services/cdn'
import { Context } from 'data/context'
// import { AreaChart } from 'components/Charts/Victory/AreaChart/AreaChart'
import { CurrencyIcon, Dropdown, Loader } from 'components/Core'
import { AreaChartWrapper, IChartProvider } from 'components/Charts/Wrappers'
import { mapProductPrice } from 'components/Charts/Victory/AreaChart/mapper'
import { fiatCodes, timeIntervals } from 'constants/index'
import { useProducts } from 'hooks/useProducts'
// import { usePrice } from 'hooks/usePrice'
// import { useCurrencies } from 'hooks/useCurrencies'

export const Price = () => {
    // #region HOOKS
    const [searchParams] = useSearchParams();
    const { currencies } = useContext(Context);
    const products = useProducts();
    // URL params
    const DEBUG = searchParams.get('DEBUG');
    const productCode = searchParams.get('productCode')
    const hideControls = searchParams.get('hideControls')
    const provider: IChartProvider = searchParams.get('provider') as IChartProvider;
    //#endregion

    //#region STATE
    const [loading, setLoading] = useState<boolean>(true);
    const [graphData, setGraphData] = useState<IGraphDataPoint[]>([])
    const [graphColor, setGraphColor] = useState<string>('#212EEE')
    // controls
    const [counterAsset, setCounterAsset] = useState<{
        value: IFiatCode,
        label: string
    }>({
        value: searchParams.get('counterAsset') as IFiatCode,
        label: searchParams.get('counterAsset') as string,
    })
    const timeFromUrl = searchParams?.get('timeInterval') as string;
    const [timeInterval, setTimeInterval] = useState<{
        value: ITimeFrameValue,
        label: string
    }>({
        value: searchParams.get('timeInterval') as ITimeFrameValue,
        label: timeIntervals.find((t: any) => t.value === timeFromUrl)?.label || timeFromUrl,
    })
    // derived state
    const productType = products?.find?.((p: any) => p.code === productCode)?.category;
    //#endregion

    // #region HANDLERS
    const handleTimeInterval = (item: { label: string, value: string }) => {
        setTimeInterval({
            label: item.label,
            value: item.value as ITimeFrameValue
        })
    }
    const handleCounterAsset = (item: { label: string, value: string }) => {
        setCounterAsset({
            label: item.label,
            value: item.value as IFiatCode
        })
    }
    //#endregion

    //#region LIFECYCLE
    useEffect(() => {
        fetchPriceChart({
            productCode: productCode || '',
            productType,
            timeFrame: timeInterval.value || '1',
            baseCurrency: counterAsset.value || 'ZAR'
        }).then((response: any) => {
            setGraphData(response.Values);
            // @ts-ignore
            setGraphColor(currencies?.[productCode]?.colors?.primary)
        }).catch((error: any) => {
            console.log('error', error)
        }).finally(() => setLoading(false));
    }, [productCode, productType, currencies, timeInterval, counterAsset])
    //#endregion

    return (
        <div>
            <>
                <div style={{ color: graphColor, textAlign: 'right', width: 'calc(100% - 1rem)', paddingLeft: '1rem', display: 'flex', flexDirection: 'row', alignItems: 'end' }}>
                    <div style={{ flexGrow: '1' }} />
                    <div style={{ flexShrink: '1', paddingRight: '3rem', display: 'flex', flexDirection: 'row' }}>

                        <span style={{ marginLeft: '0rem', marginTop: '0.1rem', fontWeight: '600', fontSize: '1.1rem', marginRight: '0.5rem' }}>
                            {productCode}
                        </span>
                        <CurrencyIcon code={productCode} />
                    </div>
                </div>
            </>
            {loading ? (
                <Loader />
            ) : (
                <>
                    {
                        !hideControls || (hideControls === 'false' || hideControls === '0') ? (
                            <div style={{ width: '16.5rem', position: 'absolute', left: '1rem', top: '1rem', zIndex: '10', display: 'flex', flexDirection: 'row' }}>
                                <div style={{ marginLeft: '1rem', minWidth: '6rem' }}>
                                    <Dropdown
                                        value={counterAsset}
                                        onChange={handleCounterAsset}
                                        options={fiatCodes}
                                    />
                                </div>
                                <div style={{ marginLeft: '1rem', minWidth: '8.5rem' }}>
                                    <Dropdown
                                        value={timeInterval}
                                        onChange={handleTimeInterval}
                                        options={timeIntervals}
                                    />
                                </div>
                            </div>
                        ) : null
                    }
                    <AreaChartWrapper
                        data={mapProductPrice(graphData)}
                        provider={provider || 'victory'}
                        color={graphColor}
                    />
                </>
            )}
            {
                DEBUG === 'true' || DEBUG === '1' || DEBUG === 'yes' ? (
                    <>
                        <div style={{ width: '100%', padding: '1rem' }}>
                            <div>DEBUG:</div>
                            <ul style={{ width: 'fit-content', margin: 'auto', marginTop: '1rem', textAlign: 'left' }}>
                                <li>{counterAsset ? `productCode = ${productCode}` : ''}</li>
                                <li>{counterAsset ? `counterAsset = ${counterAsset.value}` : ''}</li>
                                <li>{counterAsset ? `timeInterval = ${timeInterval.value}` : ''}</li>
                                <li>{counterAsset ? `provider = ${provider}` : ''}</li>
                            </ul>
                        </div>
                    </>
                ) : null
            }
            <div></div>
        </div>
    )
}